export enum SCREEN_SIZES {
    XXS = 320,
    XS = 576,
    WDGT = 764,
    MD = 768,
    LG = 992,
    XL = 1200,
    XXL = 1440
}
